/**
 * Created by coolguy on 2017/4/17.
 */
const clueFromArray = [
  "客户介绍",
  "电话预约",
  "现场参会者",
  "搜索引擎",
  "广告",
  "网站",
  "小程序",
  "H5",
  "其它",
];
export const clueFrom = clueFromArray.map((one) => {
  return {
    key: one,
    name: one,
  };
});

export const expressList = [
  "EMS快递",
  "申通快递",
  "顺丰快递",
  "圆通快递",
  "韵达快递",
  "百世汇通快递",
  "天天快递",
  "中通快递",
  "宅急送快递",
  "中国邮政",
  "全峰快递",
  "国通快递",
  "京东快递",
  "速尔快递",
  "快捷快递",
  "日日顺物流",
  "中铁快运",
  "优速快递",
  "龙邦快递",
  "德邦物流",
  "如风达快递",
  "联昊通快递",
  "国际Fedex",
  "Fedex国内",
  "DHL快递",
  "信丰快递",
  "E邮宝",
  "忠信达快递",
  "长通物流",
  "USPS快递",
  "华企快递",
  "芝麻开门快递",
  "邮政小包",
  "尼尔快递",
  "增益快递",
  "宇鑫物流",
  "星程宅配快递",
  "安能物流",
  "大达物流",
  "高考录取通知书",
  "AOL快递",
  "成都东骏快递",
  "苏宁快递",
  "UPU-Universal Postal Union",
  "全一快递",
  "华宇物流",
  "全日通快递",
  "丰程物流",
  "安能小包",
  "百世快运",
  "民航快递",
  "中邮物流",
  "佳吉快运",
  "万象物流",
  "贝海国际快递",
  "墨尔本骏丰快递",
  "骏达快递",
  "全信通快递",
  "UPS快递",
  "TNT快递",
  "一邦快递",
  "盛辉物流",
  "亚风快递",
  "D速快递",
  "大田物流",
  "佳怡物流",
  "加运美快递",
  "全晨快递",
  "OCS快递",
  "盛丰物流",
  "新邦物流",
  "程光快递",
  "丰达快递",
  "原飞航物流",
  "晋越快递",
  "越丰快递",
  "安捷快递",
  "AAE快递",
  "运通中港快递",
  "DPEX快递",
  "远成物流",
  "广东邮政物流",
  "Aramex国际快递",
  "国际邮政快递",
  "北京一统飞鸿快递",
  "乐捷递快递",
  "三态速递",
  "传志快递",
  "共速达物流|快递",
  "百福东方物流",
  "伟邦(SCS)快递",
  "平安达",
  "源安达快递",
  "递四方速递",
  "顺捷丰达快递",
  "嘉里大通物流",
  "东方快递",
  "传喜快递",
  "飞豹快递",
  "京广快递",
  "飞远物流",
  "城市之星",
  "RPX保时达",
  "CityLinkExpress",
  "城市100",
  "成都立即送快递",
  "巴伦支",
  "大洋物流快递",
  "店通快递",
  "凡宇快递",
  "昊盛物流",
  "河北建华快递",
  "急先达物流",
  "穗佳物流",
  "圣安物流",
  "赛澳递",
  "山东海红快递",
  "微特派",
  "城际快递",
  "Fardar",
  "恒路物流",
  "海外环球快递",
  "金大物流",
  "跨越速运",
  "顺鑫(KCS)快递",
  "明亮物流",
  "民邦快递",
  "闽盛快递",
  "希优特快递",
  "祥龙运通快递",
  "亿顺航快递",
  "成都奔腾国际快递",
  "济南中天万运",
  "郑州建华快递",
  "飞特物流",
  "华翰物流",
  "宝通达",
  "出口易物流",
  "誉美捷快递",
  "宽容物流",
  "南北快递",
  "万博快递",
  "速呈宅配",
  "晟邦物流",
  "百千诚国际物流",
  "高铁快递",
  "冠达快递",
  "好来运快递",
  "户通物流",
  "华航快递",
  "黄马甲快递",
  "合众速递",
  "捷特快递",
  "久易快递",
  "快优达速递",
  "蓝弧快递",
  "门对门快递",
  "陪行物流",
  "日昱物流",
  "上海林道货运",
  "世运快递",
  "奥硕物流",
  "新顺丰（NSF）快递",
  "大金物流",
  "中国远洋运输(COSCON)",
  "宇宏物流",
  "佳宇物流",
  "港快速递",
  "快淘速递",
  "速通物流",
  "安迅物流",
  "香港邮政",
  "日本邮政",
  "新加坡邮政(Sing Post)",
  "中铁物流",
  "贝邮宝",
  "燕文物流",
  "飞洋快递",
  "佐川急便",
  "恒宇运通",
  "蒙速快递",
  "五环速递",
  "思迈快递",
  "佳惠尔快递",
  "安得物流",
  "荣庆物流",
  "大顺物流",
  "方方达物流",
  "汇文快递",
  "速捷快递",
  "德国DHL快递",
  "百腾物流",
  "DCS快递",
  "DPD快递",
  "腾迅达物流",
  "品骏快递",
  "蓝天快递",
  "UEQ快递",
  "XRU快递",
  "远成快运",
  "爱尔兰邮政(AN POST)",
  "韩国邮政",
  "挪威邮政",
  "澳大利亚邮政",
  "意大利邮政",
  "新西兰邮政(NZPost)",
  "比利时邮政(BPost)",
  "德国邮政(Deutsche Post)",
  "西班牙邮政",
  "荷兰邮政",
  "泰国邮政",
  "北京邮政快递",
  "加拿大邮政",
  "丹麦邮政",
  "俄速通快递",
  "俄罗斯邮政",
  "乌克兰邮政",
  "马来西亚邮政",
  "芬兰邮政",
  "印度邮政",
  "波兰邮政",
  "泛捷国际快递",
  "八达通快递",
  "易客满快递",
  "速派快递",
  "中邮快递",
  "澳邮中国快运",
  "PCA Express",
  "韩国ADP快递",
  "A2U快递",
  "笨鸟快递",
  "爱沙尼亚邮政",
  "突尼斯邮政",
  "瑞士邮政",
  "明大快递",
  "美国申通快递",
  "Quantium",
  "OnTrac快递",
  "希腊邮政",
  "全通快递",
  "TNT UK",
  "捷记方舟快递",
  "佳成国际快递",
  "葡萄牙邮政",
  "GLS快递",
  "GATI快递",
  "南非邮政",
  "Gati-KWE快递",
  "GSM快递",
  "UPS i-parcel",
  "巴西邮政",
  "沙特邮政",
  "柬埔寨邮政_Cambodia Post",
  "越南邮政_Vietnam Post",
  "Chronopost Portugal",
  "捷买送(Buy Logic)快递",
  "台湾邮政(Taiwan Post)",
  "Speed Post",
  "老挝邮政",
  "阿联酋邮政(Emirates Post)",
  "Cuckoo布谷鸟快递",
  "DHL eCommerce",
  "Asendia USA",
  "日本黑猫宅急便(Yamato Japan)",
  "China Post",
  "英国皇家邮政(Royal Mail)",
  "Parcel Force",
  "DPD Ireland",
  "DPD Germany",
  "捷克邮政(Czech Post - Česká pošta)",
  "Go Fly",
  "Chronopost France",
  "法国邮政(La Poste)",
  "智利邮政(Correos Chile)",
  "锦程国际物流",
  "罗马尼亚邮政(Poșta Română)",
  "白俄罗斯邮政(Belpost)",
  "土耳其邮政(PTT Posta)",
  "保加利亚邮政(Bulgarian Posts)",
  "冰岛邮政(Iceland Post)",
  "立陶宛邮政(Lietuvos Paštas)",
  "塞浦路斯邮政(Cyprus Post)",
  "匈牙利邮政(Magyar Posta)",
  "克罗地亚邮政(Hrvatska Pošta)",
  "瑞典邮政(PostNord)",
  "澳门邮政",
  "以色列邮政(Israel Post)",
  "阿根廷邮政(Correo Argentino)",
  "尼日利亚邮政(NiPost)",
  "巴基斯坦邮政(Pakistan Post)",
  "拉脱维亚邮政(Latvijas Pasts)",
  "卡塔尔邮政(Q Post)",
  "印度尼西亚邮政(Pos Indonesia)",
  "阿富汗邮政(Afghan Post)",
  "Nova Poshta",
  "黎巴嫩邮政(Liban Post)",
  "塞尔维亚邮政(POŠTA SRBIJE)",
  "伊朗邮政(Iran Post)",
  "斯洛伐克邮政(Slovenská pošta)",
  "天峰国际物流",
  "One World 物流",
  "云途物流",
  "孟加拉国邮政(Bangladesh Post)",
  "UK MAIL",
  "Sky Net",
  "法国Colissimo",
  "菲律宾邮政（Philippine Post）",
  "埃及邮政(Egypt Post)",
  "新西兰Fast Way 快递",
  "澳大利亚Fast Way 快递",
  "新西兰CourierPost快递",
  "爱尔兰Fastway快递",
  "奥地利邮政(Austrian Post)",
  "速丰达快递",
  "易达通快递",
  "CFE 超峰快递",
  "翼速物流",
  "速翼快递",
  "苏驰物流",
  "顺达快递",
  "方舟快递",
  "FOX快递",
  "美速达快递",
  "兆速达物流",
  "优寄快递",
  "亿翔快递",
  "飞鹰物流",
  "卢森堡邮政(Post Luxembourg)",
  "马耳他邮政(Malta Post)",
  "乌拉圭邮政(Correo Uruguayo)",
  "Pos Laju",
  "坦桑尼亚邮政(TANZANIA POSTA)",
  "百慕大邮政(Bermuda post)",
  "秘鲁邮政(Peru Post)",
  "委内瑞拉邮政",
  "哥伦比亚邮政",
  "墨西哥邮政",
  "阿尔巴尼亚邮政",
  "荷属安的列斯邮政",
  "亚美尼亚邮政",
  "厄瓜多尔邮政",
  "卢旺达邮政",
  "阿鲁巴邮政",
  "萨尔瓦多邮政",
  "塞内加尔邮政",
  "马其顿邮政",
  "埃塞俄比亚邮政",
  "马达加斯加邮政",
  "阿塞拜疆邮政",
  "马尔代夫邮政",
  "斯洛文尼亚邮政",
  "巴哈马邮政",
  "马里邮政",
  "所罗门群岛邮政",
  "巴巴多斯邮政",
  "加蓬邮政",
  "格鲁吉亚邮政",
  "毛里塔尼亚邮政",
  "毛里求斯邮政",
  "贝宁邮政",
  "加纳邮政",
  "摩尔多瓦邮政",
  "不丹邮政",
  "蒙古邮政",
  "波黑邮政",
  "圭亚那邮政",
  "黑山邮政",
  "博茨瓦纳邮政",
  "莫桑比克邮政",
  "缅甸邮政",
  "乌干达邮政",
  "尼泊尔邮政",
  "开曼群岛邮政",
  "乌兹别克斯坦邮政",
  "科特迪瓦邮政",
  "巴布亚新几内亚邮政",
  "瓦努阿图邮政",
  "牙买加邮政",
  "巴拉圭邮政",
  "哥斯达黎加邮政",
  "约旦邮政",
  "赞比亚邮政",
  "古巴邮政",
  "哈萨克斯坦邮政",
  "津巴布韦邮政",
  "肯尼亚邮政",
  "摩洛哥邮政",
  "文莱邮政",
  "多米尼加邮政(INPOSDOM)",
  "新干线快递",
  "澳洲新干线快递",
  "EWE快递",
  "准实快递",
  "景光物流",
  "QQ-EX快递",
  "斯里兰卡邮政",
  "丰通快运",
  "多多快运",
  "志行物流",
  "诚中物流",
  "HappyLink快递",
  "斑马物联网",
  "易转运",
  "吉祥邮",
  "运淘美国",
  "畅灵国际物流",
  "Hermes快递",
  "PostElbe快递",
  "德国Hermes快递",
  "英国Hermes快递",
  "天马迅达快递",
  "重点物流 APK Logistics",
  "中欧快运",
  "ASIAX快递",
  "中国流通王",
  "亚马逊物流",
  "科捷物流",
  "能达快递",
  "瑞丰速递",
  "速腾快递",
  "纵行物流",
  "京世物流",
  "华诚物流",
  "11183快递",
];

export const scores = [
  { key: "100", name: "A" },
  { key: "90", name: "A-" },
  { key: "80", name: "B+" },
  { key: "70", name: "B" },
  { key: "65", name: "B-" },
  { key: "60", name: "C" },
];

export const billStatus = [
  {
    key: "0",
    name: "已申请",
  },
  {
    key: "1",
    name: "已打印",
  },
  {
    key: "2",
    name: "已快递",
  },
];
export const roleList = [
  {
    key: "admin",
    name: "管理员",
  },
  {
    key: "areaadmin",
    name: "区域负责人",
  },
  {
    key: "areaservice",
    name: "区域服务组长", // 组长
    qid: 4,
  },
  {
    key: "videomen",
    name: "摄像师",
  },
  {
    key: "cameramen",
    name: "摄影师",
    qid: 2,
  },
  {
    key: "consult",
    name: "顾问",
    qid: 1,
  },
  {
    key: "finance",
    name: "财务",
  },
  {
    key: "sale",
    name: "商务",
    qid: 6,
  },
  /*{
    key:"diy",
    name:"自定义角色"
},*/ {
    key: "pser",
    name: "修图师",
    qid: 3,
  },
  {
    key: "quality",
    name: "品控",
    qid: 5,
  },
  {
    key: "cliper",
    name: "剪辑师",
  },
  {
    key: "workers",
    name: "其他服务人员",
  },
];

export const wholeRoleList = [
  ...roleList,
  {
    key: "groupman",
    name: "组长",
    qid: 4,
  },
  {
    // 后端有多个顾问的名字，所以都列在这里了
    key: "advisers",
    name: "顾问",
    qid: 1,
  },
  {
    key: "adviser",
    name: "顾问",
    qid: 1,
  },
  {
    key: "customer",
    name: "客户",
    qid: 7,
  },
];
export const actionTime = [
  {
    key: "4小时以内",
    name: "4小时以内",
  },
  {
    key: "4-8小时",
    name: "4-8小时",
  },
  {
    key: "8-12小时",
    name: "8-12小时",
  },
  {
    key: "12小时以上",
    name: "12小时以上",
  },
  {
    key: "其他",
    name: "其他",
  },
];
//活动类型
export const actionType = [
  {
    key: "媒体发布会",
    name: "媒体发布会",
  },
  {
    key: "会议/公开课",
    name: "会议/公开课",
  },
  {
    key: "品牌活动",
    name: "品牌活动",
  },
  {
    key: "年会/推介会",
    name: "年会/推介会",
  },
  {
    key: "户外跟拍",
    name: "户外跟拍",
  },
  {
    key: "沙龙聚会",
    name: "沙龙聚会",
  },
  {
    key: "婚礼跟拍",
    name: "婚礼跟拍",
  },
  {
    key: "体育赛事",
    name: "体育赛事",
  },
  {
    key: "其它",
    name: "其它",
  },
  {
    key: "其他",
    name: "其他",
    disabled: true,
  },
  {
    key: "市场活动",
    name: "市场活动",
  },
  {
    key: "婚礼聚会",
    name: "婚礼聚会",
  },
  {
    key: "秀场展览",
    name: "秀场展览",
  },
  {
    key: "课程培训",
    name: "课程培训",
  },
  {
    key: "文化演出",
    name: "文化演出",
  },
  {
    key: "团队旅拍",
    name: "团队旅拍",
  },
  {
    key: "峰会论坛",
    name: "峰会论坛",
  },
  {
    key: "企业年会",
    name: "企业年会",
  },
];
//活动规模
export const actionScale = [
  {
    key: "0-100人",
    name: "0-100人",
  },
  {
    key: "100-200人",
    name: "100-200人",
  },
  {
    key: "200-500人",
    name: "200-500人",
  },
  {
    key: "500-2000人",
    name: "500-2000人",
  },
  {
    key: "2000以上",
    name: "2000以上",
  },
];
export const payType = [
  {
    key: "pre-pay",
    name: "会员预付费",
  },
  {
    key: "post-pay",
    name: "后付费",
  },
  {
    key: "free",
    name: "免费合作",
  },
  {
    key: "discount",
    name: "优惠价合作",
  },
  {
    key: "against",
    name: "拍摄费冲抵",
  },
];
export const orderArea = [
  {
    key: "010",
    name: "北京",
  },
  {
    key: "021",
    name: "上海",
  },
  {
    key: "020",
    name: "广州",
  },
  {
    key: "0592",
    name: "厦门",
  },
  {
    key: "027",
    name: "武汉",
  },
];
export const orderStatus = [
  {
    key: "to-confirm",
    name: "待确认",
    hiddenInCalendar: true,
  },
  {
    key: "confirmed",
    name: "待分配",
  },
  /*{
    key:"allocated",
    name:"已分配"
},*/ {
    key: "to-scene",
    name: "待现场",
  },
  {
    key: "to-pay",
    name: "待付款",
  },
  {
    key: "payed",
    name: "已付款",
  },
  {
    key: "complete",
    name: "已完成",
  },
  {
    key: "to-check",
    name: "待审批",
    hiddenInCalendar: true,
  },
  {
    key: "to-gallery",
    name: "待装修",
    hiddenInCalendar: true,
  },
  {
    key: "to-bill",
    name: "待开票",
  },
];

export const fromType = [
  { key: "对公银行转账", name: "对公银行转账" },
  { key: "微信支付", name: "微信支付" },
  { key: "支付宝", name: "支付宝" },
  { key: "现金", name: "现金" },
  { key: "会员预付", name: "会员预付" },
  { key: "支票", name: "支票" },
  { key: "个人网银", name: "个人网银" },
  { key: "劳务抵扣", name: "劳务抵扣" },
];

export const billType = [
  {
    key: "增值税普通发票",
    name: "增值税普通发票",
  },
  {
    key: "增值税专用发票",
    name: "增值税专用发票",
  },
  {
    key: "电子发票",
    name: "电子发票",
  },
];

export const serviceType = [
  { key: "照片直播服务费", name: "照片直播服务费" },
  { key: "摄影服务费", name: "摄影服务费" },
  { key: "摄影摄像服务费", name: "摄影摄像服务费" },
  { key: "视频拍摄服务费", name: "视频拍摄服务费" },
  { key: "视频制作服务费", name: "视频制作服务费" },
  { key: "其它", name: "其它" },
];

export const actionTravel = [
  {
    name: "不需要差旅",
    key: "1",
  },
  {
    name: "客户安排",
    key: "2",
  },
  {
    name: "即享安排客户出钱",
    key: "3",
  },
  {
    name: "即享安排，客户不出钱",
    key: "4",
  },
];

export const actionDining = [
  {
    name: "不需要用餐",
    key: "1",
  },
  {
    name: "需要用餐，客户安排",
    key: "2",
  },
  {
    name: "需要用餐，即享安排",
    key: "3",
  },
];

export const priceType = [
  {
    name: "标准价",
    key: "1",
  },
  {
    name: "破价",
    key: "2",
  },
  {
    name: "资源置换",
    key: "3",
  },
  {
    name: "其他",
    key: "other",
  },
];

export const recordType = [
  { name: "自营订单", key: "default__c" },
  { name: "运营中心订单（西安和无锡）", key: "record_am02t__c" },
  { name: "摄影师带单", key: "record_37x2e__c" },
  { name: "资源置换订单", key: "record_w5k77__c" },
  { name: "客户赠送", key: "record_L023e__c" },
  { name: "客户投诉补偿", key: "record_tf4jz__c" },
];

export const listParams = {
  dir: "DESC",
  current: 1, //保持antd的风格
  pageSize: 10,
};
export const filterOpers = {
  string: [
    { key: "=", name: "等于" },
    { key: "~", name: "包含" },
    { key: "!~", name: "不包含" },
  ],
  number: [
    { key: "=", name: "等于" },
    { key: "<>", name: "不等于" },
    { key: ">=", name: "大于等于" },
    { key: "<=", name: "小于等于" },
    { key: ">", name: "大于" },
    { key: "<", name: "小于" },
  ],
  datetime: [
    { key: "=", name: "等于" },
    { key: ">=", name: "大于等于" },
    { key: "<=", name: "小于等于" },
    { key: ">", name: "大于" },
    { key: "<", name: "小于" },
  ],
  array: [
    { key: "~", name: "包含" },
    { key: "!~", name: "不包含" },
  ],
};

export const RawImageStatusMap = {
  全部: -1,
  已选: 2,
  待补: 1,
  //  以前的 待隐藏
  待删除: 3,
  未选: 0,
  待修图: 5,
  //  以前的 已删除
  已隐藏: 4,
};

// 原片状态
export const rawImageStatus = [
  { key: "0", name: "未选" },
  { key: "1", name: "待补选" },
  { key: "2", name: "已选" },
  { key: "3", name: "待删除" },
  { key: "4", name: "已删除" },
];

export const oldRawImageStatus = [
  { key: "0", name: "未选" },
  { key: "1", name: "待补选" },
  { key: "2", name: "已选" },
  { key: "3", name: "待隐藏" },
  { key: "4", name: "已隐藏" },
];

export const rawImageOrderBy = [
  { key: "0", name: "上传时间倒序", value: { orderby: "id", order: "desc" } },
  { key: "1", name: "上传时间正序", value: { orderby: "id", order: "asc" } },
  {
    key: "2",
    name: "拍摄时间倒序",
    value: { orderby: "shooting_at", order: "desc" },
  },
  {
    key: "3",
    name: "拍摄时间正序",
    value: { orderby: "shooting_at", order: "asc" },
  },
  {
    key: "4",
    name: "文件名倒序",
    value: { orderby: "file_name", order: "desc" },
  },
  {
    key: "5",
    name: "文件名正序",
    value: { orderby: "file_name", order: "asc" },
  },
];

// 对账单的状态
export const checkingType = [
  { key: "", name: "全部" },
  { key: "0", name: "待结算" },
  { key: "1", name: "已结算" },
  { key: "2", name: "待核验" },
];

export const checkingPayType = [
  { key: "0", name: "未选择" },
  { key: "1", name: "人力外包" },
  { key: "2", name: "发票报销" },
  { key: "3", name: "劳务支付" },
  { key: "4", name: "日结" },
];

export const voteType = [
  { key: "1", name: "文字投票" },
  { key: "2", name: "图片投票" },
];
export const adjustType = [
  { key: "1", name: "横板图片" },
  { key: "2", name: "竖版图片" },
];

export const filters = {
  comments: [
    { key: "content", label: "评论内容", type: "text", oper: "string" },
    { key: "createtime", label: "发布时间", type: "date", oper: "datetime" },
    {
      key: "status",
      label: "审核状态",
      type: "select",
      oper: "array",
      default: [
        { key: "wait", name: "待审核" },
        { key: "system", name: "待人工审核" },
        { key: "error", name: "不通过" },
        { key: "pass", name: "通过" },
      ],
    },
    { key: "risk", label: "风险值", type: "text", oper: "number" },
  ],
  rates: [
    { key: "name", label: "活动名称", type: "text", oper: "string" },
    {
      key: "actionstarttime",
      label: "活动开始时间",
      type: "date",
      oper: "datetime",
    },
    {
      key: "actionendtime",
      label: "活动结束时间",
      type: "date",
      oper: "datetime",
    },
    {
      key: "orderarea",
      label: "记账区域",
      type: "select",
      oper: "string",
      showAuto: true,
    },
    {
      key: "advisers",
      label: "顾问",
      type: "user",
      oper: "string",
      filter: { oper: ["adviser"] },
    },
    {
      key: "adminids",
      label: "商务",
      type: "user",
      oper: "string",
      filter: { oper: ["sale"] },
    },
    {
      key: "is_answer",
      label: "顾问评价状态",
      type: "select",
      oper: "array",
      default: [
        { key: 1, name: "已评价" },
        { key: 0, name: "未评价" },
      ],
    },
    {
      key: "send_status",
      label: "顾问发送状态",
      type: "select",
      oper: "array",
      default: [
        { key: 1, name: "已发送" },
        { key: 0, name: "未发送" },
      ],
    },
  ],
  orders: [
    { key: "consumerid", label: "客户名称", type: "consumer", oper: "string" },
    {
      key: "status",
      label: "订单状态",
      default: orderStatus,
      type: "select",
      oper: "array",
    },
    { key: "name", label: "活动名称", type: "text", oper: "string" },
    {
      key: "actionstarttime",
      label: "活动开始时间",
      type: "date",
      oper: "datetime",
    },
    {
      key: "actionendtime",
      label: "活动结束时间",
      type: "date",
      oper: "datetime",
    },
    { key: "actionaddress", label: "活动地点", type: "text", oper: "string" },
    {
      key: "adminids",
      label: "负责人",
      type: "user",
      oper: "string",
      showAuto: true,
      filter: { oper: ["oper", "areaadmin", "admin"] },
    },
    { key: "advisers", label: "顾问", type: "user", oper: "string" },
    { key: "pser", label: "修图师", type: "user", oper: "string" },
    { key: "cameramen", label: "摄影师", type: "user", oper: "string" },
    { key: "videomen", label: "摄像师", type: "user", oper: "string" },
    { key: "cliper", label: "剪辑师", type: "user", oper: "string" },
    { key: "workers", label: "其他服务人员", type: "user", oper: "string" },
    {
      key: "orderarea",
      label: "记账区域",
      type: "select",
      oper: "string",
      showAuto: true,
    },
    (window.sessionStorage.getItem("oper") || "").indexOf("admin") > -1
      ? {
        key: "department",
        label: "部门",
        type: "treeselect",
        oper: "string",
        showAuto: true,
      }
      : null,
    // {key:"paytype", label:"付款方式", type:"select", oper:"array", default:payType},
    { key: "price", label: "订单金额", type: "text", oper: "number" },
    {
      key: "centeramount",
      label: "运营结算成本",
      type: "text",
      oper: "number",
    },
    {
      key: "centerpayed",
      label: "运营结算状态",
      type: "select",
      oper: "array",
      default: [
        { key: "1", name: "已核算" },
        { key: "2", name: "待核算" },
      ],
    },
    { key: "createtime", label: "下单日期", type: "date", oper: "datetime" },
    { key: "fxiaoname", label: "订单编号", type: "custom_tag", oper: "string" },
  ].filter((it) => !!it),
  remits: [
    { key: "consumerid", label: "客户名称", type: "consumer", oper: "string" },
    { key: "orderid", label: "订单名称", type: "order", oper: "string" },
    {
      key: "status",
      label: "回款状态",
      type: "select",
      oper: "array",
      default: [
        { key: "wait", name: "待确认" },
        { key: "confirmed", name: "已确认" },
      ],
    },
    { key: "time", label: "回款时间", type: "date", oper: "datetime" },
    { key: "price", label: "回款金额", type: "text", oper: "number" },
    {
      key: "from",
      label: "回款方式",
      type: "select",
      oper: "array",
      default: fromType,
    },
    {
      key: "createby",
      label: "申请人",
      type: "user",
      oper: "string",
      showAuto: true,
    },
  ],
  bills: [
    { key: "consumerid", label: "客户名称", type: "consumer", oper: "string" },
    { key: "orderid", label: "订单名称", type: "order", oper: "string" },
    {
      key: "status",
      label: "发票状态",
      type: "select",
      oper: "array",
      default: [
        { key: "0", name: "待确认" },
        { key: "1", name: "已确认" },
        { key: "2", name: "已寄出" },
      ],
    },
    { key: "opertime", label: "开票时间", type: "date", oper: "datetime" },
    { key: "createtime", label: "申请时间", type: "date", oper: "datetime" },
    { key: "price", label: "开票金额", type: "text", oper: "number" },
    { key: "billno", label: "发票号码", type: "text", oper: "string" },
    {
      key: "type",
      label: "发票类型",
      type: "select",
      oper: "array",
      default: billType,
    },
    {
      key: "service",
      label: "服务项目",
      type: "select",
      oper: "array",
      default: serviceType,
    },
    {
      key: "createby",
      label: "申请人",
      type: "user",
      oper: "string",
      showAuto: true,
    },
  ],
  images: [
    {
      key: "uploader",
      label: "修图师",
      type: "select",
      oper: "string",
      default: "props.defaultData",
    },
    { key: "shoottime", label: "拍摄时间", type: "date", oper: "datetime" },
    { key: "uploadtime", label: "上传时间", type: "date", oper: "datetime" },
    { key: "delay", label: "延时时间", type: "text", oper: "number" },

    {
      key: "trashtype",
      label: "公开隐藏",
      type: "select",
      oper: "string",
      default: [
        { key: "0", name: "公开" },
        { key: "", name: "隐藏" },
      ],
    },
  ],
  rawimages: [
    { key: "CreatedAt", label: "上传时间", type: "date", oper: "datetime" },
    {
      key: "status",
      label: "状态",
      type: "select",
      oper: "string",
      default: rawImageStatus,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/defaultData.js